module.exports = __webpack_public_path__ + "static/media/imgNosotros3.e1e85b3e.png";